export default __webpack_public_path__ + "static/media/plan-expired.7ca847f8.svg";